import { Button, Card, Form, Modal } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useState } from "react";
import { reportActionItemPostApi } from "../../../../api";
import Loader from "../../../Loader";

function ActionModal({
  actionModal,
  setActionModal,
  actionModalData,
  auth,
  interviewType,
  interviewId,
  getReport,
}) {
  const [loading, setLoading] = useState(false);
  // console.log(actionModalData)
  const postData = async (data) => {
    const url = `${reportActionItemPostApi}?interviewId=${interviewId}&interviewType=${interviewType}`;
    try {
      setLoading(true); // Optional: to show a loading indicator

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      //   console.log(result);
      if (result.resultStatusInfo.resultCode.toLowerCase() === "success") {
        // setInterviewData(result.data.data);
        // console.log("Data posted successfully:", result.data.data);
        setActionModal(false);
        getReport();
      } else {
        console.log(result.resultStatusInfo);
      }
    } catch (err) {
      console.error("Fetch error: ", err);
    } finally {
      setLoading(false); // Optional: to hide the loading indicator
    }
  };

  const handleFinish = (value) => {
    // console.log(value);
    let req = {
      interviewActionableId: actionModalData.interviewActionableId,
      editedReference: value.reference,
      editedActionsRequired: value.actionRequired,
    };
    postData(req);
  };
  return (
    <>
      {loading && <Loader />}
      <Modal
        title={<p className="text-[#206DC5] text-2xl">Actionable items</p>}
        footer={[null]}
        //   loading={loading}
        open={actionModal}
        onCancel={() => setActionModal(false)}
        centered
        width={1000}
        style={{ backgroundColor: "#206DC5" }}
        className="custom-modal-wrap"
      >
        <Form onFinish={handleFinish}>
          <Card className="border-2">
            <p className="font-semibold text-xl">Reference</p>
            <Form.Item
              name="reference"
              className="mt-2"
              initialValue={actionModalData?.reference}
            >
              <TextArea
                //   size="large"
                style={{ height: 80, resize: "none" }}
                className="py-3"
                placeholder="Enter your reference here..."
                //   value={tagInputValue.strengthTagInputValue}
              />
            </Form.Item>
          </Card>
          <Card className="border-2 mt-2">
            <p className="font-semibold text-xl">Action required</p>
            <Form.Item
              name="actionRequired"
              className="mt-2"
              initialValue={actionModalData?.actionsRequired}
            >
              <TextArea
                //   size="large"
                style={{ height: 100, resize: "none" }}
                className="py-3"
                placeholder="Enter your action here..."
                //   value={tagInputValue.strengthTagInputValue}
              />
            </Form.Item>
          </Card>
          <div className="flex  md:justify-end justify-center  items-center gap-4 mt-6">
            <Button onClick={() => setActionModal(false)} size="large" className="md:w-[200px] w-full">
              Cancel
            </Button>
            <Button
              type="primary"
              size="large"
              className="md:w-[200px] w-full"
              htmlType="submit"
            >
              Update
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
}

export default ActionModal;
